export const initialState = {
  images: [],
  croppedImages: {},
  index: 0,
  brightnessByIndex: {},
};

export const reducer = (state, action) => {
  switch (action.type) {
    case "ADD_IMAGE": {
      // Recibe la nueva imagen y la agrega al array de imágenes
      const newIndex = state.images.length;
      return {
        ...state,
        images: [...state.images, action.payload],
        brightnessByIndex: {
          ...state.brightnessByIndex,
          [newIndex]: 1,
        },
        index: newIndex,
      };
    }

    case "SET_CROPPED_IMAGE": {
      // Recibe el índice de la imagen a modificar y la nueva imagen
      const { index, croppedImage } = action.payload;

      return {
        ...state,
        croppedImages: {
          ...state.croppedImages,
          [index]: croppedImage,
        },
      };
    }

    case "DELETE_IMAGE": {
      // Recibe el índice de la imagen a eliminar
      const newImages = state.images.filter((_, i) => i !== action.payload);

      // Actualiza brightnessByIndex, eliminando la propiedad correspondiente al índice
      let newBrightness = { ...state.brightnessByIndex };
      delete newBrightness[action.payload];

      // Elimina la imagen croppeada correspondiente
      let newCroppedImages = { ...state.croppedImages };
      delete newCroppedImages[action.payload];

      // Reajusta las claves de brightnessByIndex y croppedImages si la imagen eliminada no es la última
      if (action.payload < newImages.length) {
        const adjustedBrightness = Object.fromEntries(
          Object.entries(newBrightness).map(([key, value]) => [
            key > action.payload ? key - 1 : key,
            value,
          ])
        );
        newBrightness = adjustedBrightness;

        const adjustedCroppedImages = Object.fromEntries(
          Object.entries(newCroppedImages).map(([key, value]) => [
            key > action.payload ? key - 1 : key,
            value,
          ])
        );
        newCroppedImages = adjustedCroppedImages;
      }

      // Ajusta el índice de la imagen si es necesario
      const newIndex =
        state.index > 0 && state.index === action.payload
          ? state.index - 1
          : Math.min(state.index, newImages.length - 1);

      return {
        ...state,
        images: newImages,
        brightnessByIndex: newBrightness,
        croppedImages: newCroppedImages,
        index: newIndex,
      };
    }

    case "RESET":
      // Reinicia el estado a su valor inicial
      return initialState;

    case "SET_INDEX":
      // Recibe el nuevo índice de la imagen a mostrar
      return { ...state, index: action.payload };

    case "SET_BRIGHTNESS":
      // Recibe el índice de la imagen a modificar y el nuevo valor de brillo
      const { index, value } = action.payload;
      return {
        ...state,
        brightnessByIndex: {
          ...state.brightnessByIndex,
          [index]: value,
        },
      };

    default:
      return state;
  }
};
